import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { Router } from '@angular/router';
import { GenerateTicketModalComponent } from '../generate-ticket-modal/generate-ticket-modal.component';

@Component({
  selector: 'app-ticket-generation-landing',
  standalone: false,
  templateUrl: './ticket-generation-landing.component.html',
  styleUrl: './ticket-generation-landing.component.scss',
})
export class TicketGenerationLandingComponent implements OnInit {
  action_idx: any = null;

  ticketList: any[] = [];
  form!: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedTicketNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;

  @Output() onConfirmClicked = new EventEmitter();
  vehicleTypes: any[] = [];

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }


  clearSearchFilters() {
    this.form.reset()
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      batchReference: [''],
      vehicleTypeId: [''],
      from: [''],
      to: [''],
      offset: [''],
    });

    this.getAllVehicleTypes()
    this.search();
  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();
  }

  search() {
    this.ticketList = [];
    this.searchedTicketNotFound = false;
    this.isSearching = true;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);
    formData.append("batchReference", this.form.get('batchReference')?.value || '');
    formData.append("from", this.form.get('from')?.value || '');
    formData.append("to", this.form.get('to')?.value || '');
    formData.append("vehicleTypeId", this.form.get('vehicleTypeId')?.value || '');

    this.apiService
      .post('/ticket-batch/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.ticketList = response.data;

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedTicketNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);

          this.searchedTicketNotFound = true;
        }
      );
  }

  openDialogRef(data?: any) {
    let dialogRef = this.dialog.open(GenerateTicketModalComponent, {
      width: '450px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      disableClose: true,

      data,
    });

    return dialogRef;
  }


  viewDetails(id: number) {
    this.router.navigate(["/admin/batch/e-ticketing"], {
      queryParams: { id: id },
    });
  }

  generateNewTickets() {
    this.openDialogRef();
  }
}
